$(document).ready(function() {
  return $(".clickable").click(function(event) {
    if ($(event.target).hasClass('btn') || $(event.target).hasClass('fa')) {
      return
    }else{
      window.location = $(this).data("href");
    }
  });
});
